import React from 'react';
import { Link } from '@inertiajs/react';

export default () => {
	return (
		<Link href={route('dashboard.index')} className="flex items-center">
			<img
				src="/images/logo-256.png"
				className="cursor-pointer max-h-24"
				alt="Savrx Logo"
			/>
		</Link>
	);
};
